import React, { CSSProperties } from 'react';
import SideNavContent from './sideNavContent';
import { CustomScrollbar } from '../../components/CustomScrollbar';

export type TabletSideNavDrawerProps = {
  /** Whether the drawer is open (i.e. sidebar is NOT collapsed on tablet) */
  isOpen: boolean;
  logoIconSrc: string;
  logoTextSrc: string;
  logoIconStyle: CSSProperties;
  logoTextStyle: CSSProperties;
  /** Called when the backdrop is clicked */
  onClose: () => void;
};

const TabletSideNavDrawer: React.FC<TabletSideNavDrawerProps> = ({
  isOpen,
  logoIconSrc,
  logoTextSrc,
  logoIconStyle,
  logoTextStyle,
  onClose,
}) => {
  return (
    <>
      {/* Backdrop */}
      <div
        className={`fixed inset-0 bg-black/40 transition-opacity duration-300 ${
          isOpen
            ? 'opacity-100 pointer-events-auto'
            : 'opacity-0 pointer-events-none'
        }`}
        style={{ zIndex: 49 }}
        onClick={onClose}
        aria-hidden="true"
      />

      {/* Slide-in drawer panel */}
      <div
        className={`fixed top-0 left-0 flex flex-col h-screen px-4 py-2 bg-white transition-transform duration-300 shadow-2xl rounded-r-sm ${
          isOpen ? 'translate-x-0' : '-translate-x-full'
        }`}
        style={{ width: '220px', zIndex: 50 }}
      >
        {/* Logo row — always pinned at the top, never scrolls. No extra
            paddingLeft: the icon's inset from the row edge is baked into
            Figma's flattened logo artwork, not a CSS offset — adding padding
            here double-offsets it against the drawer's own px-4 and clips
            the text against the row's overflow-hidden edge instead. No close
            button: clicking the backdrop already closes the drawer. */}
        <div className="flex items-center gap-[5px] w-full shrink-0 overflow-hidden">
          <img
            src={logoIconSrc}
            alt="pozytron logo"
            className="shrink-0"
            style={logoIconStyle}
          />
          <img
            src={logoTextSrc}
            alt="pozytron"
            className="shrink-0"
            style={logoTextStyle}
          />
        </div>

        {/* Nav items scroll on their own here, unlike the desktop side nav —
            real tablet drawers are tall enough that the list rarely
            overflows, so folding the illustration into this scroll region
            (as desktop does) left it floating right after the last nav item
            instead of pinned to the bottom. Uses the same CustomScrollbar as
            the desktop side nav (not a native scrollbar) so the thumb sits
            in the drawer's own padding gutter instead of overlapping the nav
            item rows. */}
        <CustomScrollbar
          className="flex-1 min-h-0 mt-[37px]"
          thumbHeight={150}
          containOverscroll
        >
          <SideNavContent isIconOnly={false} />
        </CustomScrollbar>

        {/* Fixed at the bottom of the drawer regardless of how much space
            the nav list takes — kept as a sibling outside the scroll region
            so it never gets pushed out of view or floats away from the
            bottom edge on tall screens. */}
        <img
          src="/navBarIllastration.svg"
          alt="pozytron logo"
          className="shrink-0"
        />
      </div>
    </>
  );
};

export default TabletSideNavDrawer;
